import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  Button,
  Alert,
} from "@mui/material";
import { validarDatosIMC } from "./validateForm";
import {
  getAnswersOfUser,
  saveAnswers,
} from "../../../services/rest/users/medicalQuestions";
import { handleError } from "../../../utils/handleError";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";

const GeneralQuestionsModal = ({
  open,
  setOpen,
  setLoading,
  answers,
  setAnswers,
}) => {
  const { _id } = useSelector((state) => state.userReducer);
  const [questionsData, setQuestionsData] = React.useState({
    altura: answers?.altura ?? 0,
    peso: answers?.peso ?? 0,
    enfermedadCronica: answers?.enfermedadCronica ?? "No",
    antecedentesFam: answers?.antecedentesFam ?? "No",
    cirugiasImp: answers?.cirugiasImp ?? "No",
    medicacionAct: answers?.medicacionAct ?? "No",
    alergiasCon: answers?.alergiasCon ?? "No",
  });
  const [error, setError] = React.useState("");
  const onClose = () => {
    setOpen(false);
  };
  const handleChange = (field) => (event) => {
    setQuestionsData({ ...questionsData, [field]: event.target.value });
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      setError("");
      const { valido, mensaje } = validarDatosIMC(
        questionsData?.altura,
        questionsData?.peso
      );

      if (!valido) {
        setError(mensaje);
        setLoading(false);
        return;
      }

      const answersFormat = {
        section: "general",
        userAnswers: questionsData,
      };
      await saveAnswers(answersFormat);
      const responseAnswers = await getAnswersOfUser(_id);
      // console.log("responses", responseAnswers);
      setAnswers(responseAnswers ?? {});
      setLoading(false);
      toast.success("Se guardaron con éxito sus respuestas");
      onClose();
    } catch (error) {
      const { message } = handleError(error);
      toast.error(
        `En estos momentos no se pudo guardar sus respuestas. \n ${message}`
      );
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={() => onClose(false)} maxWidth="xs" fullWidth>
      <DialogTitle>Información General de Salud</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={3} sx={{ pt: 2 }}>
          {error && (
            <Grid item xs={12}>
              <Alert severity="error">{error}</Alert>
            </Grid>
          )}

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Altura (metros)"
              type="number"
              value={questionsData.altura}
              onChange={handleChange("altura")}
              inputProps={{ step: "0.01", min: 0 }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Peso (kg)"
              type="number"
              value={questionsData.peso}
              onChange={handleChange("peso")}
              inputProps={{ step: "0.1", min: 0 }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="¿Padeces alguna enfermedad crónica?"
              value={questionsData.enfermedadCronica}
              onChange={handleChange("enfermedadCronica")}
              multiline
              rows={2}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="¿Tienes antecedentes familiares de enfermedades relevantes?"
              value={questionsData.antecedentesFam}
              onChange={handleChange("antecedentesFam")}
              multiline
              rows={2}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="¿Has tenido alguna cirugía o intervención médica importante?"
              value={questionsData.cirugiasImp}
              onChange={handleChange("cirugiasImp")}
              multiline
              rows={2}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="¿Tomas algún medicamento actualmente?"
              value={questionsData.medicacionAct}
              onChange={handleChange("medicacionAct")}
              multiline
              rows={2}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="¿Tienes alergias conocidas? (Medicamentos, alimentos, etc.)"
              value={questionsData.alergiasCon}
              onChange={handleChange("alergiasCon")}
              multiline
              rows={2}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()} variant="outlined" color="white">
          Cancelar
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          sx={{ backgroundColor: "#e7ef7d" }}
        >
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GeneralQuestionsModal;
